import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";
import { Reveal } from "./Reveal";
type Crumb = {
  label: string;
  href?: string;
};
type Props = {
  eyebrow: string;
  title: React.ReactNode;
  lead?: string;
  crumbs?: Crumb[];
  actions?: React.ReactNode;
  aside?: React.ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  lead,
  crumbs,
  actions,
  aside
}: Props) {
  return <section className="relative overflow-hidden border-b border-line" data-id="element-458" data-mp="1cb9nmku7s7fx">
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden data-id="element-459" data-mp="17d827t9bfw1a" />
      <div className="blue-glow pointer-events-none absolute inset-0" aria-hidden data-id="element-460" data-mp="12e4x68tc5ptb" />
      <div className="shell relative grid gap-10 pb-[clamp(3.5rem,6vw,8rem)] pt-[clamp(3rem,6vw,7rem)] xl:grid-cols-[1.4fr_1fr] xl:items-end" data-id="element-461" data-mp="xfbu7abodh7e">
        <Reveal data-id="element-462" data-mp="3n5otfq63qllc">
          {crumbs && <nav aria-label="Breadcrumb" className="mb-8" data-id="element-463" data-mp="3n29f4pk95gkz">
              <ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted" data-id="element-464" data-mp="3i4rgbrzy8hqp">
                <li data-id="element-465" data-mp="2t51pvl9vjvn2"><Link to="/" className="hover:text-fg" data-id="element-466" data-mp="2t51rfppiw3p6">Home</Link></li>
                {crumbs.map(c => <li key={c.label} className="flex items-center gap-1.5" data-id="element-467" data-mp="2y1s6qati6v9j">
                    <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-468" data-mp="2j6lydh6xqkd1" />
                    {c.href ? <Link to={c.href} className="hover:text-fg" data-id="element-469" data-mp="2o4nje7nx8tr5">{c.label}</Link> : <span aria-current="page" className="text-fg-2" data-id="element-470" data-mp="2o708d4s3k4dp">{c.label}</span>}
                  </li>)}
              </ol>
            </nav>}
          <p className="t-eyebrow mb-6 flex items-center gap-3 text-accent-soft" data-id="element-471" data-mp="2f50nu2hvii60"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-472" data-mp="20furcmaf761t" />{eyebrow}</p>
          <h1 className="t-h1 max-w-[18ch]" data-id="element-473" data-mp="25efizxblwhen">{title}</h1>
          {lead && <p className="t-lead mt-7 max-w-[54ch] text-fg-2" data-id="element-474" data-mp="25ep8zkwniokc">{lead}</p>}
          {actions && <div className="mt-10 flex flex-wrap gap-3" data-id="element-475" data-mp="1rfxwg2xftayb">{actions}</div>}
        </Reveal>
        {aside && <Reveal delay={0.08} data-id="element-476" data-mp="1veydph09o5j7">{aside}</Reveal>}
      </div>
    </section>;
}